module.exports = __webpack_public_path__ + "img/share_crop.0fe49dff.png";